module.exports = __webpack_public_path__ + "img/highlight_mesh.d35ab470.svg";